export const record_limits = [10, 15, 20, 25] //used to set the limits from one signle place
export const default_limit = 10;
